import React from 'react'
import styles from './DealsCard.module.scss'
import { dateFormat } from 'helpers/date'
import { Link } from 'react-router-dom'
import ProfileAvatar from 'components/CRM/UI/components/ProfileAvatar/ProfileAvatar'
import asideModalStore from 'Stores/asideModalStore'
import ReasonRejectModal from './ReasonRejectModal/ReasonRejectModal'
import AddEditDeferredDeal from './AddEditDeferredDeal/AddEditDeferredDeal'
import { ReactComponent as FileIcon } from 'components/UI/icons/file-list-2-line.svg'
import { checkPermList } from '../../../../helpers'
import { permissions } from '../../../../settings/permissions'

const DealCard = ({
  deal_name,
  client,
  lead,
  columnsLength,
  id,
  manager,
  created_at,
  budget,
  funnelId,
  measureRef,
  client_text_name,
  reject_reason,
  translate,
  last_update_status_deal_timestamp,
  isLastColumn,
  isSelected,
  onToggleSelection,
  has_tasks,
  has_overdue_tasks,
  tags,
  planned_admission_year,
}) => {
  // const date =
  //   isLastColumn && last_update_status_deal_timestamp
  //     ? last_update_status_deal_timestamp
  //     : created_at

  const addRejectReasonModal = () => {
    const ms = {
      modalBodyComponent: () => <ReasonRejectModal />,
      button: 'Save',
      link: `integration/deals/${id}`,
      title: 'Добавить причину отказа',
      is_put: true,
      isResponsive: true,
      crm: true,
      // onSubmitSuccess: () => window.location.reload(),
      valid: {
        reject_reason: 'required',
      },
    }
    asideModalStore.activity(ms, {
      deal_name: deal_name,
      manager: manager?.id,
      client: client?.id,
      client_name: client?.name,
      reject_reason: reject_reason,
      budget: budget,
      funnels: [funnelId],
    })
  }

  const AddDeferredDeal = () => {
    const ms = {
      modalBodyComponent: () => <AddEditDeferredDeal />,
      button: 'Save',
      link: `integration/deferred_deals`,
      title: 'Отложить сделку',
      isResponsive: true,
      crm: true,
      // onSubmitSuccess: () => window.location.reload(),
      onBeforeSubmit: (data) => {
        const deferredDays = data?.deferred_until

        let deferredDate = null

        if (
          deferredDays !== null &&
          deferredDays !== undefined &&
          deferredDays !== ''
        ) {
          const today = new Date()

          const futureDate = new Date(today)
          futureDate.setDate(today.getDate() + Number(deferredDays))

          const year = futureDate.getFullYear()
          const month = String(futureDate.getMonth() + 1).padStart(2, '0')
          const day = String(futureDate.getDate()).padStart(2, '0')

          deferredDate = `${year}-${month}-${day}`
        }

        return {
          ...data,
          deferred_until: deferredDate,
        }
      },
      valid: {
        deferred_until: 'required',
      },
    }
    asideModalStore.activity(ms, {
      deal: id,
      funnel: funnelId,
    })
  }

  return (
    <div ref={measureRef} className={styles.dealsCardContainer}>
      <div className={styles.typeDataAndFullNameBlock}>
        <div className={styles.photoAndName}>
          <ProfileAvatar
            name={client?.name || lead?.client || client_text_name}
            width='16px'
            height='16px'
            fs='6px'
          />
          <div className={styles.fullName}>
            {client?.name
              ? client?.name
              : lead?.client
                ? lead?.client
                : client_text_name
                  ? client_text_name
                  : translate?.no_name}
          </div>
        </div>
        <div className={styles.data}>
          {dateFormat(created_at, 'dd.mm.YYYY')}
        </div>
      </div>
      <div className={styles.dealsName}>
        <Link
          target='_blank'
          to={`/crm/customer-card/${id}/?funnel_id=${funnelId}`}
        >
          <span className={styles.dealLink}>{deal_name}</span>
        </Link>
        {checkPermList(permissions.add_deferred_deals_crm) && (
          <div onClick={AddDeferredDeal}>Отложить</div>
        )}
      </div>
      <div className={styles.typeDealsInfo}>
        <div>{manager?.name}</div>
      </div>
      {planned_admission_year && (
        <div className={styles.typeDealsInfo}>
          <div>Планируемый год поступления: {planned_admission_year}</div>
        </div>
      )}

      {tags.length > 0 && (
        <div className={styles.typeDealsTags}>
          {tags.map((tag) => (
            <div key={tag}>{tag.name}</div>
          ))}
        </div>
      )}

      <div className={styles.typeDealsAndDateBlock}>
        <div className={styles.dealsBudget}>₸ {budget}</div>
        <div className={styles.cont_btns}>
          {isLastColumn && columnsLength > 1 && (
            <div onClick={addRejectReasonModal} className={styles.reason}>
              {translate?.reason_reject}
            </div>
          )}
          <div className={styles.selectionCheckbox}>
            {has_overdue_tasks && (
              <FileIcon
                className={styles.overdueIcon}
                title={'У сделки есть просроченные задачи'}
              />
            )}

            {has_tasks && has_overdue_tasks === false && (
              <FileIcon
                className={styles.activeIcon}
                title={'У сделки есть задача'}
              />
            )}

            <button
              className={`${styles.selectButton} ${isSelected ? styles.selected : ''}`}
              onClick={(e) => {
                e.stopPropagation()
                onToggleSelection()
              }}
              title={isSelected ? 'Снять выделение' : 'Выбрать для объединения'}
            >
              {isSelected ? '✓' : '+'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DealCard
